var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFixNorth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.83,
    height: 30.44,
    viewBox: "0 0 29.83 30.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.69,28.4L16.19,.79c-.24-.49-.73-.79-1.27-.79s-1.03,.31-1.27,.79L.14,28.4c-.29,.59-.13,1.31,.38,1.72,.51,.42,1.25,.42,1.77,0l12.62-9.98,12.62,9.98c.26,.2,.57,.3,.88,.3s.63-.1,.89-.31c.51-.41,.67-1.13,.38-1.72Zm-15.65-11.16l-8.62,6.81L14.92,4.64v12.3c-.31,0-.62,.1-.88,.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixNorth);
export default __webpack_public_path__ + "static/media/fixNorth.d718a27f1d8ddacbf2d6deae10a2c761.svg";
export { ForwardRef as ReactComponent };